import jstz from "jstz";

const integration = {
    iframe: document.getElementById("kt-integration"),
    authHeaderName: 'X-Kicktipp-Login',
    sessionHeaderName: 'X-Kicktipp-Session',
    urlHeaderName: 'X-Kicktipp-Url',
    darkmodeHeaderName: 'X-Kicktipp-Darkmode',
    timezoneHeaderName: 'X-Kicktipp-Timezone',
    keepParams: ["id", "pageId", "page_id", "pageid", "path", "contentid"],
    baseUrl: location.protocol + "//" + location.hostname,
    kurzname: location.pathname.split("/")[1],
    callback: null,
    page: '',
    token: '',
    init: function () {
        window.addEventListener('message', this.inbox, false);
        if (this.storage.get(this.darkmodeHeaderName) === null) {
            this.storage.set(this.darkmodeHeaderName, "auto");
        }
        this.checkDoppelFrame();
        this.callback = () => {
            integration.fetch(integration.initialUrl())
        }
        this.storage.request(this.authHeaderName)
        this.iframe.onload = integration.sendDarkmodeStatus
    },
    initialUrl() {
        const initialUrl = new URL(this.baseUrl);
        let urlParams = new URLSearchParams(window.location.search)
        let parentUrl = new URL(urlParams.get("url"));
        let parentParams = parentUrl.searchParams;
        this.page = parentParams.get("br_p") || `/${this.kurzname}/`;
        let pageParts = this.page.split("?");
        initialUrl.pathname = pageParts[0];
        if (pageParts.length > 1) {
            initialUrl.search = pageParts[1];
        }
        return initialUrl.pathname + initialUrl.search;
    },
    parentOrigin: function () {
        let urlParams = new URLSearchParams(window.location.search)
        let parentUrl = new URL(urlParams.get("url"));
        return parentUrl.origin;
    },
    integrationsUrl: function () {
        let urlParams = new URLSearchParams(window.location.search)
        let parentUrl = new URL(urlParams.get("url"));
        parentUrl.hash = "";
        let params = new URLSearchParams();
        for (const key of parentUrl.searchParams.keys()) {
            if (this.keepParams.filter(keepParam => keepParam === key).length > 0) {
                params.set(key, parentUrl.searchParams.get(key));
            }
        }
        parentUrl.search = params.toString();
        return parentUrl.toString();
    },
    // Wenn die Session gelöscht wurde (vor allem Safari),
    // fragen wir beim parent zunächst den Login an und
    // führen den Request erst dann aus. siehe sendStorage
    execute(fn) {
        integration.callback = fn;
        const noSession = this.storage.get(this.sessionHeaderName) === null;
        if (noSession) {
            integration.storage.request(integration.authHeaderName)
            return
        }
        integration.callback();
    },
    inbox: function (event) {
        if (event.origin !== integration.baseUrl
            && event.origin !== integration.parentOrigin()) {
            return
        }
        try {
            let message = event.data;
            if (message.event === "reload") {
                // Event "reload" wird von Fehlerseiten des Loadbalancers getriggered
                integration.fetch(integration.baseUrl + `/${integration.kurzname}/`)
            }
            // Sobald die Antwort vom Parent kommt, rufen wir den Callback auf
            if (message.event === "sendStorage") {
                integration.storage.recieve(message.key, message.value)
                if (integration.callback != null) {
                    integration.callback();
                }
            }
            if (message.event === "fetch") {
                integration.execute(() => {
                    integration.fetch(message.url, message.options)
                })
            }
            if (message.event === "fetchjson") {
                integration.execute(() => {
                    integration.fetchjson(message.url, message.options)
                        .then((json) => {
                            integration.iframe.contentWindow.postMessage({
                                event: 'resultjson',
                                url: message.url,
                                data: json
                            }, integration.baseUrl);
                        })
                })
            }
            if (message.event === "height") {
                integration.fixHeight(message.height)
            }
            if (message.event === "click") {
                parent.postMessage(message, integration.parentOrigin());
            }
            if (message.event === "scroll") {
                parent.postMessage(message, integration.parentOrigin());
            }
            if (message.event === "darkmode") {
                integration.darkmode(message.status)
            }
        } catch (e) {
            console.error(e);
        }
    },
    fixHeight: function (height) {
        if (!isNaN(height)) {
            const newHeight = parseInt(height);
            this.iframe.height = newHeight + "px";
            parent.postMessage({
                event: 'height',
                height
            }, integration.parentOrigin());
        }
    },
    storage: {
        // localStorage ist im Incognito-Mode nicht erreichbar
        map: {},
        get(key) {
            try {
                return window.localStorage.getItem(key);
            } catch (e) {
                return this.map[key];
            }
        },
        setAndSend(key, value) {
            this.set(key, value)
            this.send(key, value)
        },
        set(key, value) {
            try {
                window.localStorage.setItem(key, value);
            } catch (e) {
                this.map[key] = value;
            }
        },
        request(key) {
            parent.postMessage({event: "getStorage", key}, integration.parentOrigin())
        },
        recieve(key, value) {
            try {
                window.localStorage.setItem(key, value);
            } catch (e) {
                this.map[key] = value;
            }
        },
        send(key, value) {
            parent.postMessage({event: "setStorage", key, value}, integration.parentOrigin())
        }
    },
    fetch: function (url, options = {}) {
        options.headers = options.headers || {};
        this.addHeader(options.headers)
        options.headers['Accept'] = 'text/html'
        fetch(url, options)
            .then(async (response) => {
                this.saveHeaders(response)
                let html = await response.text()
                this.iframe.setAttribute("srcdoc", html);
                parent.postMessage({event: "history", path: url}, integration.parentOrigin())
            })
        this.page = url.split(this.baseUrl).pop();
        if (this.page.indexOf("/") !== 0) {
            this.page = "/" + this.page;
        }
    },
    fetchjson: function (url, options = {}) {
        options.headers = options.headers || {};
        this.addHeader(options.headers)
        return fetch(url, options)
            .then((response) => {
                this.saveHeaders(response)
                return response.json()
            })
    },
    addHeader(headers) {
        headers[this.authHeaderName] = this.storage.get(this.authHeaderName);
        headers[this.sessionHeaderName] = this.storage.get(this.sessionHeaderName);
        headers[this.darkmodeHeaderName] = this.storage.get(this.darkmodeHeaderName);
        headers[this.urlHeaderName] = this.integrationsUrl();
        headers[this.timezoneHeaderName] = jstz.determine().name()
    },
    saveHeaders(response) {
        this.storage.setAndSend(this.authHeaderName, response.headers.get(this.authHeaderName));
        if (response.headers.has(this.sessionHeaderName)) {
            // X-Kicktipp-Session wird vom Backend nur gesetzt, wenn sich was an der Session ändert
            // Die Session darf nicht im parent Frame gespeichert werden.
            this.storage.set(this.sessionHeaderName, response.headers.get(this.sessionHeaderName));
        }
    },
    checkDoppelFrame: function () {
        if (this.isDoppelFrame()) {
            const errorUrl = new URL(this.baseUrl);
            errorUrl.pathname = `/${this.kurzname}/error/doppelframe`;
            this.fetch(errorUrl.toString())
            throw new Error('The integration must be in your top frame');
        }
    },
    isDoppelFrame: function () {
        try {
            if (window.navigator.userAgent === "cypress") {
                return window.parent.parent !== window.top;
            }
            return window.parent !== window.top;
        } catch (e) {
            return true;
        }
    },
    darkmode: function (status) {
        if (!["on", "off", "auto"].includes(status)) {
            status = status ? "on" : "off";
        }
        if (status !== integration.storage.get(integration.darkmodeHeaderName)) {
            integration.storage.setAndSend(integration.darkmodeHeaderName, status)
            integration.sendDarkmodeStatus()
        }
    },
    sendDarkmodeStatus() {
        integration.iframe.contentWindow.postMessage({
            event: "darkmode",
            status: integration.storage.get(integration.darkmodeHeaderName)
        }, integration.baseUrl);
    }
}
integration.init();
